import { formatearImporte } from '../../../nucleo/importes/formatoDeImporte.js';

/**
 * CÓMO QUEDA REPARTIDA LA DEUDA INICIAL — bloque derivado del alta y de la
 * corrección de la tarjeta (RF-248, RF-249, RN-687, prototipo v39).
 *
 * LAS TRES CIFRAS SE DERIVAN AL VUELO Y NINGUNA SE GUARDA (RN-687): el exigible
 * inicial es deuda inicial menos diferido y no existe columna para él. Esto no es
 * una resta de la deuda, es una PARTICIÓN: la suma vuelve a dar la deuda inicial, y
 * el renglón de la suma está aquí justamente para que se vea (RN-699).
 *
 * LA PANTALLA NO VALIDA: el veredicto `cabe` viene de la lógica de este módulo y
 * solo sirve para avisar mientras se escribe. El rechazo real lo da el servidor
 * (RN-688, D-390).
 */
export function RepartoDeLaDeuda({ reparto, codigoISO, datoDePrueba = 'reparto-de-la-deuda' }) {
  if (!reparto) return null;

  if (reparto.hayImporteIlegible) {
    return (
      <div className="card" style={{ margin: 12 }} data-prueba={datoDePrueba}>
        <h4 style={{ margin: '0 0 6px', fontSize: 11.5 }}>CÓMO QUEDA TU DEUDA</h4>
        <div className="fila">
          <span className="crece">Falta una cifra para poder separarla</span>
          <b>—</b>
        </div>
      </div>
    );
  }

  const noCabe = reparto.cabe === false;

  return (
    <div className="card" style={{ margin: 12 }} data-prueba={datoDePrueba}>
      <h4 style={{ margin: '0 0 6px', fontSize: 11.5 }}>CÓMO QUEDA TU DEUDA</h4>

      <div className="fila">
        <span className="crece">Deuda con la que empezó</span>
        <b data-prueba="reparto-deuda-inicial">{formatearImporte(reparto.deudaInicial, codigoISO)}</b>
      </div>
      <div className="fila">
        <span className="crece">En compras a meses que aún no te cobran</span>
        <b data-prueba="reparto-diferido">{formatearImporte(reparto.diferido, codigoISO)}</b>
      </div>
      <div className="fila">
        <span className="crece">{noCabe ? 'Quedaría en cobro' : 'Queda en cobro'}</span>
        <b data-prueba="reparto-en-cobro">{formatearImporte(reparto.enCobro, codigoISO)}</b>
      </div>

      {/* La suma se muestra porque es el hecho que tranquiliza: separar no cambia
          lo que debes (RN-699). */}
      <div className="fila">
        <span className="crece">Suma</span>
        <b data-prueba="reparto-suma">{formatearImporte(reparto.deudaInicial, codigoISO)}</b>
      </div>

      {reparto.diferido === 0 && (
        <span className="ayuda" data-prueba="reparto-sin-diferido">
          Sin compras a meses, lo que se espera que pagues cada periodo es toda tu deuda al corte.
        </span>
      )}
    </div>
  );
}
